import * as React from 'react'
import { InviewProps } from '../blocksState'
import { CtaBlockLayout } from '../ctaBlockLayout'
import { urlToImage } from '../../../../utils/images'
import { ContactPerson } from '../../cmsPageState'

export type ContactPersonProps = {
  index: number
  inview?: InviewProps
  contactPerson: ContactPerson
}

export function ContactPersonBlockLayout(props: ContactPersonProps) {
  const { index, inview, contactPerson } = props
  return (
    <CtaBlockLayout
      type='big'
      index={index}
      title={contactPerson.Title}
      intro={contactPerson.Intro || ''}
      phone={{
        title: contactPerson.PhoneNumber || '',
        text: contactPerson.PhoneText || ''
      }}
      inview={inview}
      primaryAction={{
        url: contactPerson.PrimaryButtonUrl?.Url || '',
        title: contactPerson.PrimaryButtonTitle || ''
      }}
      image={
        contactPerson.ImageUrl
          ? urlToImage(contactPerson.ImageUrl.Url, {
              alt: contactPerson.ImageUrl.Title
            })
          : undefined
      }
    />
  )
}
